import React from 'react'

import Banner_image2 from "../../assets/serive-background1.png";

import Team from "../../assets/hubsyntax-team.png";



export default function Uiuxdesign() {

  return (

    <>

      <section className="section service-page image-left" id="Webdevelopment" style={{ background: `url(${Banner_image2})`, }}>
        <div className='container'>
          <div className="banner-wrapper">
            <div className='design-wrap'>
              <div className='img-wrap' id="counter-box">
                <div className='image-wrapper'>
                  <div className='img'>
                    <img src={Team} alt="Web Development" />
                  </div>

                </div>
                <div className='content-wrapper'>
                  <p className='tagline'>About</p>
                  <h2 className='title' >Why HubSyntax</h2>
                  <p className='content'>At HubSyntax, we are a dedicated Shopify agency committed to helping businesses build, optimize, and scale their online stores. Unlike other agencies, our team has a deep understanding of Shopify ecosystem with the latest industry trends. </p>

                  <p className='content'> Whether you're launching your first store or scaling a global brand, HubSyntax is your trusted partner for long-term Shopify success. </p>

                </div>

              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}
